import { AbstractBlock } from './AbstractBlock';
import beautify from 'js-beautify';
import { BlocklyWorkSpaceType } from '../@types/BlocklyWorkspaceType';
import { GlobalImport } from '../utils/GlobalImport';
import { MessageDialog } from '../../framework/frontend/MessageDialog';
const Blockly = GlobalImport.getBlockly();

export class AssembleCodeEnum {
  static FUNC_PLACE_HOLER = '/*func_placeholder*/';
  static HTML_INNER_PLACE_HOLER = '<!--html_placeholder-->';
  static ASSET_PLACE_HOLER = `<!--assets_placeholder-->`;
  static JAVASCRIPT_PLACE_HOLDER = `/*javascript_placeholder*/`;
  static JAVASCRIPT_AFTER_BODY_PLACE_HOLDER = `/*javascript_after_body_placeholder*/`;
}

export class BlocklyAframeBuilder {
  private workspace = null;
  private js_code = '';

  constructor(workspace: BlocklyWorkSpaceType, js_code: string) {
    this.workspace = workspace;
    this.js_code = js_code;
  }

  static isARCode(aframe_code: string) {
    return aframe_code.includes('arjs=');
  }

  /**
   * ワークスペースのコードを取得
   */
  get workspaceToJavascript(): string {
    return Blockly.JavaScript.workspaceToCode(this.workspace);
  }

  private get codeForMargeFunction(): string {
    // トップブロックをマージしつつチェック
    const topBlocks = this.getTopBlockTapleAndValid();
    const startBlock = topBlocks.startBlock;
    const functionBlocks = topBlocks.functionBlocks;

    if (!startBlock) {
      MessageDialog.alert('スタートブロックが取得できませんでした。');
      return functionBlocks.join('\n');
    }

    const funccode = functionBlocks.join('\n');
    let merged = startBlock;
    if (funccode) {
      merged = merged.replace(
        AssembleCodeEnum.FUNC_PLACE_HOLER,
        AssembleCodeEnum.FUNC_PLACE_HOLER + funccode
      );
    }

    const assets = AbstractBlock.assetsList;
    if (assets) {
      merged = merged.replace(
        AssembleCodeEnum.ASSET_PLACE_HOLER,
        AssembleCodeEnum.ASSET_PLACE_HOLER + assets
      );
    }
    return merged;
  }

  /**
   * 関数ブロックがあるならTrue
   */
  private hasFunctionBlock(): boolean {
    if (!this.workspace) {
      throw new Error('ワークスペースが取れませんでした。at getFunctionBlock');
    }
    const topblocks = this.workspace.getTopBlocks(true);
    if (topblocks.length <= 1) {
      return false;
    } else {
      return true;
    }
  }

  /**
   * 関数ブロックを取得
   */
  private getFunctionBlocks() {
    const topblocks = this.workspace.getTopBlocks(true);
    const functionBlocks = [];
    for (const topblock of topblocks) {
      if (topblock.type !== 'a-scene-start' && topblock.type !== 'ar-a-scene-start') {
        functionBlocks.push(topblock);
      }
    }
    return functionBlocks;
  }

  /**
   * 最上位ブロックをタプルとして取得
   */
  private getTopBlockTapleAndValid(): { startBlock: string; functionBlocks: string[] } {
    const topblocks = this.workspace.getTopBlocks(true);
    const startBlockTypes = ['ar-a-scene-start', 'a-scene-start', 'model-viewer-simple'];
    const canTopBlockTypes = [
      'collide-start',
      'ar-marker-found',
      'comment-out',
      'logic_function_v2',
      'logic_init_process',
    ];
    let startBlock = '';
    const functionBlocks: string[] = [];

    if (topblocks.filter((block) => startBlockTypes.includes(block.type)).length > 1) {
      MessageDialog.warn('スタートブロックが複数あります。\n1つ以外は無視されます');
    }

    for (const topblock of topblocks) {
      console.dir(topblock.type);
      const blockCode = Blockly.JavaScript.blockToCode(topblock);
      const hasStart = startBlockTypes.includes(topblock.type);
      const canTop = canTopBlockTypes.includes(topblock.type);

      if (hasStart) {
        startBlock = blockCode;
      } else if (canTop) {
        functionBlocks.push(blockCode);
      } else {
        MessageDialog.warn('不要なブロックが存在します。トップブロックのみが許可されます');
      }
    }
    return { startBlock: startBlock, functionBlocks: functionBlocks };
  }

  /**
   * 関数ブロックパートを取得
   * @returns
   */
  public getFunctionBlockCode(): string {
    const funcblocks = this.getFunctionBlocks();
    let funcCodes = '';
    for (const funcblock of funcblocks) {
      const funcCode = Blockly.JavaScript.blockToCode(funcblock);
      funcCodes += funcCode + '\n';
    }
    return funcCodes;
  }

  public get workspaceToCodeForCrossOrigin(): string {
    const code = this.workspaceToCode;
    return code.replace(/run.blockvrock.com/g, 'blockvrock.com');
  }

  /**
   * 関数ブロックをマージしてコードにする。
   */
  public get workspaceToCode(): string {
    // 前回持っていたStaticエリアをクリア
    // AbstractBlock.clearStatic();

    try {
      /**
       * 関数ブロックなどをマージしたコード
       */
      let code = this.codeForMargeFunction;

      /**
       * 固定HTML部分を追加
       */
      const html = AbstractBlock.htmlList;
      if (html) {
        code = code.replace(
          AssembleCodeEnum.HTML_INNER_PLACE_HOLER,
          AssembleCodeEnum.HTML_INNER_PLACE_HOLER + html
        );
      }

      /**
       * Body後のJSロード部分
       */
      const afterJs = AbstractBlock.javaScriptAfterBodyJsList;
      if (afterJs) {
        code = code.replace(
          AssembleCodeEnum.JAVASCRIPT_AFTER_BODY_PLACE_HOLDER,
          AssembleCodeEnum.JAVASCRIPT_AFTER_BODY_PLACE_HOLDER + afterJs
        );
      }

      const beautifyOptions = {
        indent_size: 2, // インデントサイズ
        end_with_newline: true, // 最後に改行を含める
        preserve_newlines: false, // 改行を維持する
        max_preserve_newlines: 0, // 改行が連続した時に除去する
        wrap_line_length: 0, // 長い行で改行しない
        wrap_attributes_indent_size: 0, // 長い属性で改行しない
        extra_liners: '', // /htmlやbodyで改行しない
      };
      return beautify.html(code, beautifyOptions);
    } catch (error) {
      throw new Error(`${error};ツールボックスにないブロックがつかわれている可能性があります`);
    }
  }
}
